<template>
  <v-card tile flat class="my-5">
    <v-card-title>
      Daftar Balai
    </v-card-title>
    <v-divider />
    <v-card-text class="pa-0">
      <v-list>
        <template v-for="(instansi, id) in instansiBalai">
          <div :key="id">
            <v-divider v-if="id !== 0" class="my-1" />
            <v-list-item>
              <v-list-item-avatar color="blue">
                <v-icon dark>mdi-home</v-icon>
              </v-list-item-avatar>
              <v-list-item-content class="py-0 px-1">
                <v-row>
                  <v-col cols="12" lg="8">
                    <div class="body-1 font-weight-medium">
                      {{ instansi.nama }}
                    </div>
                    <div class="body-2 grey--text">
                      {{ instansi.instansi_id }}
                    </div>
                  </v-col>
                  <v-col cols="12" lg="4" class="my-auto">
                    <v-btn color="primary" @click="onDetail(instansi)">Lihat Laporan</v-btn>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
          </div>
        </template>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'ComponentDirektorat',
  data() {
    return {
      instansiBalai: [],
    };
  },
  mounted() {
    this.fetchInstansiBalai();
  },
  methods: {
    ...mapActions('preferensi', ['getInstansiBalai']),

    async fetchInstansiBalai() {
      this.instansiBalai = await this.getInstansiBalai();
    },

    onDetail(instansi) {
      this.$router.push({
        name: 'iht-balai-detail',
        params: { dinas_id: instansi.instansi_id },
      });
    },
  },
};
</script>

<style scoped></style>
